module.exports = __webpack_public_path__ + "141d4a85/img/question-icon.06c20c5d.svg";